import { Text } from "@/components/ui";
import type { Folder } from "lucide-react";

export const EmptyPreviewState = ({
  title,
  description,
  icon: Icon,
}: {
  title: string;
  description: string;
  icon: typeof Folder;
}) => {
  return (
    <div className="flex h-full min-h-[320px] items-center justify-center p-8">
      <div className="mx-auto max-w-md text-center">
        <div className="bg-primary/10 mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl">
          <Icon className="text-primary h-7 w-7" />
        </div>
        <Text
          variant="title"
          className="block w-full max-w-full truncate text-nowrap break-normal"
          title={title}
        >
          {title}
        </Text>
        {description ? (
          <Text variant="subHeading" className="mt-2">
            {description}
          </Text>
        ) : null}
      </div>
    </div>
  );
};
